import { StatusTag, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { Score, SubScore, getSubScoreLabel } from "../types";

export function ClearTag(props: { label: string; size?: "sm" | "md" }) {
  const { label, size = "sm" } = props;
  return (
    <StatusTag
      statusInfoIcon={false}
      fill="background-accent-blue-weak"
      leftIcon="inventory"
      color="text-accent-blue-strong"
      testID="clear-tag-value"
    >
      <Text
        style={size === "sm" ? "global/label-small" : "global/heading-medium"}
      >
        {label}
      </Text>
    </StatusTag>
  );
}

export function ReviewTag(props: { label: string; size?: "sm" | "md" }) {
  const { label, size = "sm" } = props;
  return (
    <StatusTag
      statusInfoIcon={false}
      leftIcon="quick_reference_all"
      fill="background-accent-orange-weak"
      color="text-accent-orange-strong"
      testID="review-tag-value"
    >
      <Text
        style={size === "sm" ? "global/label-small" : "global/heading-medium"}
      >
        {label}
      </Text>
    </StatusTag>
  );
}

export function RejectTag(props: { label: string; size?: "sm" | "md" }) {
  const { label, size = "sm" } = props;
  return (
    <StatusTag
      statusInfoIcon={false}
      leftIcon="quick_reference_all"
      fill="background-accent-red-weak"
      color="text-accent-red-strong"
      testID="reject-tag-value"
    >
      <Text
        style={size === "sm" ? "global/label-small" : "global/heading-medium"}
      >
        {label}
      </Text>
    </StatusTag>
  );
}

export function UnableToCompleteTag(props: {
  label: string;
  size?: "sm" | "md";
}) {
  const { label, size = "sm" } = props;
  return (
    <StatusTag
      statusInfoIcon={false}
      leftIcon="block"
      fill="background-accent-neutral-weak"
      color="icon-weak"
      testID="unable-to-complete-tag-value"
    >
      <Text
        style={size === "sm" ? "global/label-small" : "global/heading-medium"}
      >
        {label}
      </Text>
    </StatusTag>
  );
}

export type CheckScoreTagProps = {
  score: Score | null | "";
  subScore: SubScore | null | "";
  size?: "sm" | "md";
};

export function CheckScoreTag(props: CheckScoreTagProps) {
  const { score, subScore, size = "sm" } = props;
  const { t } = useTranslation();

  if (!score || !subScore || score === "NOT_APPLICABLE") {
    return null;
  }

  const ScoreTag =
    subScore === "UNABLE_TO_COMPLETE" || subScore === "RESTRICTED"
      ? UnableToCompleteTag
      : score === "REVIEW"
        ? ReviewTag
        : score === "REJECT"
          ? RejectTag
          : ClearTag;
  return <ScoreTag label={getSubScoreLabel(t, subScore)} size={size} />;
}
